// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/collection/collection-header/collection-header.component.scss
// module id = 142
// module chunks = 0